import { myLocalStorage } from '../myLocalStorage';
import { CompanyType, isPublisherCompany } from './Company';
import { Enrollment, EnrollmentType } from './Enrollment';

export enum Role {
  ADMINISTRATOR = 'ADMINISTRATOR',
  ACADEMIC = 'ACADEMIC',
  REPRESENTATIVE = 'REPRESENTATIVE',
  PUBLISHER_ADMIN = 'PUBLISHER_ADMIN',
  DISTRIBUTOR = 'DISTRIBUTOR',
  BOOKSTORE_ADMINISTRATOR = 'BOOKSTORE_ADMINISTRATOR',

  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
}

export const displayRole = (role: Role) => {
  return pascalCase(role.toLowerCase());
};

export const pascalCase = (input: string): string => {
  return input.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
    return g1.toUpperCase() + g2;
  });
};

export const getAdminPath = (): string => {
  const company = myLocalStorage.getItem('company');
  if (isPublisherCompany(company)) {
    return '/publisher';
  } else if (isAdminRole()) {
    return '/administrator';
  }

  return '';
};

export const isAdminRole = (): boolean => {
  const company = myLocalStorage.getItem('company');
  return company?.type === CompanyType.INTERNAL;
};

export const isAccountManagerRole = (): boolean => {
  const me = myLocalStorage.getItem('person');
  return me?.role === Role.ACCOUNT_MANAGER;
};

export const isDistributorRole = (): boolean => {
  const company = myLocalStorage.getItem('company');
  return company?.type === CompanyType.DISTRIBUTOR;
};

export const isPublisherRole = (): boolean => {
  const company = myLocalStorage.getItem('company');
  return company?.type === CompanyType.PUBLISHER;
};

export const isBookstoreAdminRole = (): boolean => {
  const me = myLocalStorage.getItem('person');
  return me?.role === Role.BOOKSTORE_ADMINISTRATOR;
};

const isEnrollment = (
  enrollmentOrType: Enrollment | EnrollmentType | null | undefined
): enrollmentOrType is Enrollment =>
  enrollmentOrType != null && typeof enrollmentOrType === 'object' && 'type' in enrollmentOrType;

export const isStudentRole = (
  enrollmentOrType: Enrollment | EnrollmentType | null | undefined
): boolean => {
  const enrollmentType = isEnrollment(enrollmentOrType) ? enrollmentOrType.type : enrollmentOrType;
  return enrollmentType === EnrollmentType.STUDENT || enrollmentType === EnrollmentType.OBSERVER;
};

export const isInstructorRole = (
  enrollmentOrType: Enrollment | EnrollmentType | null | undefined
): boolean => {
  const enrollmentType = isEnrollment(enrollmentOrType) ? enrollmentOrType.type : enrollmentOrType;
  return enrollmentType === EnrollmentType.INSTRUCTOR || enrollmentType === EnrollmentType.TA;
};
